import { HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, switchMap  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../../core/env.service';
import { RuleAppliedPropertyDTO  } from '../../model/RuleAppliedPropertyDTO';
import { RuleAppliedDTO  } from '../../model/RuleAppliedDTO';
import {QueryBuilderFilterRule} from '../../model/QueryBuilderFilterRule';
import { FilterResultDTO } from '../../model/FilterResultDTO';
import { QueryBuilderFilterRuleDTO } from '../../model/QueryBuilderFilterRuleDTO';
import { FilterDTO } from '../../model/FilterDTO';
import { AuthService } from 'src/app/core/auth-service.component';
import { OptionDTO } from '../../model/OptionDTO';

@Injectable()
export class TmsService {
    constructor(private _httpClient: HttpClient,public _env: EnvService,
        private _httpClientBackend: HttpClient,
        private _httpHandler: HttpBackend,private _authService: AuthService) {
        this._httpClientBackend = new HttpClient(_httpHandler);
    }

    GetUnAppliedRules(): Observable<Array<RuleAppliedPropertyDTO>> {
        return this._httpClient.get<Array<RuleAppliedPropertyDTO>>(this._env.apiRule +'Tms/GetUnAppliedRules')
        .pipe(map((res: Array<RuleAppliedPropertyDTO>) => res));
    }
    GetClientCodeName(page:number, pageSize:number): Observable<Array<OptionDTO>> {

        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientCodeNameByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {

        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientIdByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientSubDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientSubDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientSubDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientSubDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientLocationFilter(page:number, pageSize:number,filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientSubLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientSubLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    
    GetClientSubLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientSubLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetClientCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCodeName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCodeNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierIdFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    
    GetCarrierLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCurrency(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierCurrency?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCurrencyFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierCurrencyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCarrierCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetShipMode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetShipmentMode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetShipModeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetShipmentModeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetSrvceType(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetServiceType?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetSrvceTypeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetServiceTypeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetFreightTerm(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetFreightTerms?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetFreightTermFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetFreightTermsFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetGeoPortCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetPortCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetGeoPortCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetPortCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetAccessorialName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetAccessorial?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    
    GetAccessorialNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Production/GetAccessorialFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetAppliedRulesByFilterId(filterId:Number): Observable<Array<RuleAppliedDTO>> {
        return this._httpClient.get<Array<RuleAppliedDTO>>(this._env.apiRule +'Tms/GetAppliedRulesByFilterId?filterId='+filterId)
        .pipe(map((res: Array<RuleAppliedDTO>) => res));
    }

    SaveAppliedRules(data:Array<RuleAppliedDTO>):Observable<Array<RuleAppliedDTO>> {
        return this._httpClient.post<Array<RuleAppliedDTO>>(this._env.apiRule +'Tms/AdddRuleApplied',data)
        .pipe(map((res: Array<RuleAppliedDTO>) => res));
    }   
    
    SaveAppliedProperties(data:Array<RuleAppliedPropertyDTO>):Observable<Array<RuleAppliedPropertyDTO>> {
        return this._httpClient.post<Array<RuleAppliedPropertyDTO>>(this._env.apiRule +'Tms/AddRuleProperties',data)
        .pipe(map((res: Array<RuleAppliedPropertyDTO>) => res));
    }   
    
    GetFilters(page:Number,pageSize:Number): Observable<FilterResultDTO> {
        return this._httpClient.get<FilterResultDTO>(this._env.apiRule +'Tms/GetFilter?page='+page+'&&pageSize='+pageSize)
        .pipe(map((res: FilterResultDTO) => res));
    }

    GetFilterById(id: Number) {
        return this._httpClient.get<FilterDTO>(this._env.apiRule +'Tms/GetFilterById?id='+id)
        .pipe(map((res: FilterDTO) => res)); 
    }
    
    GetFilterLineWithChild(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'Tms/GetFilterLineById?id='+id)
        .pipe(map((res: any) => res));
    }

    SaveFilter(data:FilterDTO): Observable<any> {
        return this._httpClient.post<FilterDTO>(this._env.apiRule +'Tms/SaveFilter',data)
        .pipe(map((res: any) => res));
    }

    SaveFilterLine(data:QueryBuilderFilterRuleDTO): Observable<QueryBuilderFilterRuleDTO> {
        return this._httpClient.post<QueryBuilderFilterRuleDTO>(this._env.apiRule +'Tms/SaveFilterLine',data)
        .pipe(map((res: QueryBuilderFilterRuleDTO) => res));
    }

    UpdateFilter(data:FilterDTO): Observable<FilterDTO> {
        return this._httpClient.post<FilterDTO>(this._env.apiRule +'Tms/UpdateFilter',data)
        .pipe(map((res: FilterDTO) => res));
    }

    UpdateFilterLine(data:QueryBuilderFilterRule): Observable<QueryBuilderFilterRule> {
        return this._httpClient.post<QueryBuilderFilterRule>(this._env.apiRule +'Tms/UpdateFilterLine',data)
        .pipe(map((res: QueryBuilderFilterRule) => res));
    }


    DeleteRulesWithChild(id:Number): Observable<QueryBuilderFilterRule> {
        return this._httpClient.get<QueryBuilderFilterRule>(this._env.apiRule +'Tms/DeleteRules?id='+id)
        .pipe(map((res: QueryBuilderFilterRule) => res));
    }
    MassDeleteRulesList(data:Array<Number>):Observable<Array<Number>> {
        return this._httpClient.post<Array<Number>>(this._env.apiRule +'Tms/MassDeleteRulist',data)
        .pipe(map((res: Array<Number>) => res));
    }
}